import LegalPage from "@/components/LegalPage";
export default function Terms() {
  return <LegalPage contentKey="termsConditions" />;
}
